
document.addEventListener('DOMContentLoaded', function () {
    var encodedCredentials = '';
    var entryData = {};
    var selectedText = '';
    
    // Session management variables
    var SESSION_DURATION = 10 * 60 * 1000; // 10 minutes in milliseconds
    var WARNING_THRESHOLD = 60 * 1000; // Show warning at 1 minute remaining
    var sessionTimeout = null;
    var countdownInterval = null;
    var sessionExpiryTime = null;

    var appContainer = document.getElementById('app-container');
    var loginContainer = document.getElementById('login-container');
    var loginForm = document.getElementById('login-form');
    var hardEntryField = document.getElementById('hard-entry');
    var easyEntryField = document.getElementById('easy-entry');
    var editToggle = document.getElementById('edit-toggle');
    var sendButton = document.getElementById('save-btn');
    var nextButton = document.getElementById('next-btn');
    var generateButton = document.getElementById('gen-btn');
    var synonymButton = document.getElementById('synonym-btn');
    var languageSelect = document.getElementById('language-select');
    var statusBar = document.getElementById('status-bar');
    var progressBar = document.getElementById('progress-bar');
    var difficultySlider = document.getElementById('difficulty-slider');
    var difficultyValue = document.getElementById('difficulty-value');
    
    // Session management elements
    var sessionInfo = document.getElementById('session-info');
    var sessionTimer = document.getElementById('session-timer');
    var logoutBtn = document.getElementById('logout-btn');
    var sessionExpiredOverlay = document.getElementById('session-expired-overlay');
    var reloginBtn = document.getElementById('relogin-btn');

    difficultySlider.addEventListener('input', () => {
        difficultyValue.innerText = difficultySlider.value;
        renewSessionLease(); // Renew on interaction
    });

    loginForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var username = document.getElementById('username').value;
        var password = document.getElementById('password').value;
        encodedCredentials = window.btoa(username + ':' + password);

        initializeApp({ encodedCredentials: encodedCredentials });
    });

    editToggle.addEventListener('change', function () {
        if (editToggle.checked) {
            hardEntryField.removeAttribute('readonly');
            difficultySlider.value = '10';
            difficultyValue.innerText = '10';
        } else {
            hardEntryField.setAttribute('readonly', true);
        }
        renewSessionLease(); // Renew on interaction
    });

    easyEntryField.addEventListener('mouseup', function () {
        const start = easyEntryField.selectionStart;
        const end = easyEntryField.selectionEnd;

        if (start !== end) {
            selectedText = {
                text: easyEntryField.value.substring(start, end),
                start: start,
                end: end
            };
            console.log('Selected text:', selectedText.text);
        } else {
            selectedText = '';
        }
        renewSessionLease(); // Renew on interaction
    });
    
    // Renew session on input activities
    easyEntryField.addEventListener('input', renewSessionLease);
    hardEntryField.addEventListener('input', renewSessionLease);
    languageSelect.addEventListener('change', renewSessionLease);

    nextButton.addEventListener('click', function () {
        renewSessionLease();
        window.location.reload();
    });

    sendButton.addEventListener('click', function () {
        renewSessionLease();
        var payload = {
            easy: easyEntryField.value,
            hard: editToggle.checked ? hardEntryField.value : entryData.entry.hard,
            date: Date.now(),
            lang: languageSelect.value,
            original: editToggle.checked ? easyEntryField.value : entryData.entry.easy,
            id: editToggle.checked ? -1 : entryData.id,
            classification: parseInt(difficultySlider.value, 10)
        };

        var saveXhr = new XMLHttpRequest();
        saveXhr.open('POST', '/save-entry', true);
        saveXhr.setRequestHeader('Authorization', 'Basic ' + encodedCredentials);
        saveXhr.setRequestHeader('Content-Type', 'application/json');
        saveXhr.onreadystatechange = function () {
            if (saveXhr.readyState === 4) {
                if (saveXhr.status >= 200 && saveXhr.status < 300) {
                    alert('Leitura fácil enviada con sucesso!');
                    window.location.reload();
                } else {
                    alert('Envio sin sucesso. Intente novamente o contacte el administrador.');
                }
            }
        };
        saveXhr.send(JSON.stringify(payload));
    });

    generateButton.addEventListener('click', function () {
        renewSessionLease();
        var payload = {
            text: hardEntryField.value,
            lang: languageSelect.value
        };
        var generateXhr = new XMLHttpRequest();
        generateXhr.open('POST', '/generate', true);
        generateXhr.setRequestHeader('Authorization', 'Basic ' + encodedCredentials);
        generateXhr.setRequestHeader('Content-Type', 'application/json');
        generateXhr.onreadystatechange = function () {
            if (generateXhr.readyState === 4) {
                if (generateXhr.status >= 200 && generateXhr.status < 300) {
                    var response = generateXhr.responseText;
                    easyEntryField.value = response;
                    autoResize(easyEntryField);
                } else {
                    alert('Error al generar la lectura fácil. Intente nuevamente.');
                }
            }
        }
        generateXhr.send(JSON.stringify(payload));
    })

    synonymButton.addEventListener('click', function () {
        renewSessionLease();
        if (!selectedText || !selectedText.text.trim()) {
            alert('Please select some text first.');
            return;
        }

        var payload = {
            text: selectedText.text,
            lang: languageSelect.value
        };

        var synonymXhr = new XMLHttpRequest();
        synonymXhr.open('POST', '/synonym', true);
        synonymXhr.setRequestHeader('Authorization', 'Basic ' + encodedCredentials);
        synonymXhr.setRequestHeader('Content-Type', 'application/json');
        synonymXhr.onreadystatechange = function () {
            if (synonymXhr.readyState === 4) {
                if (synonymXhr.status >= 200 && synonymXhr.status < 300) {
                    var response = JSON.parse(synonymXhr.responseText);

                    const before = easyEntryField.value.slice(0, selectedText.start);
                    const after = easyEntryField.value.slice(selectedText.end);
                    easyEntryField.value = before + response + after;

                    autoResize(easyEntryField);

                    // Optional: reset selection
                    selectedText = '';
                } else {
                    alert('Error al generar sinónimos. Intente nuevamente.');
                }
            }
        };
        synonymXhr.send(JSON.stringify(payload));
    });
    
    // Logout button handler
    logoutBtn.addEventListener('click', function() {
        if (confirm('¿Estás seguro de que quieres cerrar la sesión?')) {
            performLogout();
        }
    });
    
    // Relogin button handler
    reloginBtn.addEventListener('click', function() {
        window.location.reload();
    });

    // Session Management Functions
    function startSession() {
        sessionExpiryTime = Date.now() + SESSION_DURATION;
        localStorage.setItem('sessionExpiry', sessionExpiryTime);
        localStorage.setItem('encodedCredentials', encodedCredentials);
        
        sessionInfo.style.display = 'flex';
        startCountdown();
        
        // Set timeout for automatic logout
        sessionTimeout = setTimeout(expireSession, SESSION_DURATION);
    }
    
    function renewSessionLease() {
        if (!sessionExpiryTime) return;
        
        // Clear existing timeout
        clearTimeout(sessionTimeout);
        clearInterval(countdownInterval);
        
        // Reset expiry time
        sessionExpiryTime = Date.now() + SESSION_DURATION;
        localStorage.setItem('sessionExpiry', sessionExpiryTime);
        
        // Restart countdown and timeout
        startCountdown();
        sessionTimeout = setTimeout(expireSession, SESSION_DURATION);
        
        // Reset visual warning
        sessionTimer.classList.remove('warning');
    }
    
    function startCountdown() {
        updateTimerDisplay();
        countdownInterval = setInterval(function() {
            var remaining = sessionExpiryTime - Date.now();
            
            if (remaining <= 0) {
                clearInterval(countdownInterval);
                return;
            }
            
            updateTimerDisplay();
            
            // Add warning class when less than 1 minute remains
            if (remaining <= WARNING_THRESHOLD) {
                sessionTimer.classList.add('warning');
            }
        }, 1000);
    }
    
    function updateTimerDisplay() {
        var remaining = Math.max(0, sessionExpiryTime - Date.now());
        var minutes = Math.floor(remaining / 60000);
        var seconds = Math.floor((remaining % 60000) / 1000);
        sessionTimer.textContent = 
            (minutes < 10 ? '0' : '') + minutes + ':' + 
            (seconds < 10 ? '0' : '') + seconds;
    }
    
    function expireSession() {
        clearInterval(countdownInterval);
        clearTimeout(sessionTimeout);
        
        // Clear credentials
        localStorage.removeItem('encodedCredentials');
        localStorage.removeItem('sessionExpiry');
        encodedCredentials = '';
        sessionExpiryTime = null;
        
        // Show expired modal
        sessionExpiredOverlay.style.display = 'flex';
        
        // Disable all interactive elements
        disableApp();
    }
    
    function performLogout() {
        clearInterval(countdownInterval);
        clearTimeout(sessionTimeout);
        
        localStorage.removeItem('encodedCredentials');
        localStorage.removeItem('sessionExpiry');
        encodedCredentials = '';
        sessionExpiryTime = null;
        
        window.location.reload();
    }
    
    function disableApp() {
        // Disable all form elements
        var inputs = document.querySelectorAll('input, textarea, select, button');
        inputs.forEach(function(input) {
            input.disabled = true;
        });
    }
    
    function checkExistingSession() {
        var storedExpiry = localStorage.getItem('sessionExpiry');
        var storedCredentials = localStorage.getItem('encodedCredentials');
        
        if (storedExpiry && storedCredentials) {
            var remaining = parseInt(storedExpiry) - Date.now();
            
            if (remaining > 0) {
                // Valid session exists, restore it
                encodedCredentials = storedCredentials;
                sessionExpiryTime = parseInt(storedExpiry);
                
                // Adjust timeout to remaining time
                sessionTimeout = setTimeout(expireSession, remaining);
                startCountdown();
                sessionInfo.style.display = 'flex';
                
                // Re-initialize app with stored credentials
                initializeApp({ encodedCredentials: encodedCredentials });
                return true;
            } else {
                // Session expired, clean up
                localStorage.removeItem('encodedCredentials');
                localStorage.removeItem('sessionExpiry');
            }
        }
        return false;
    }

    function initializeApp(data) {
        encodedCredentials = data.encodedCredentials;

        var re_xhr = new XMLHttpRequest();
        re_xhr.open('GET', '/random-entry', true);
        re_xhr.setRequestHeader('Authorization', 'Basic ' + encodedCredentials);
        re_xhr.onreadystatechange = function () {
            if (re_xhr.readyState === 4 && re_xhr.status === 200) {
                var response = JSON.parse(re_xhr.responseText);
                entryData = response;

                hardEntryField.innerText = response.entry.hard;
                easyEntryField.value = response.entry.easy;

                autoResize(easyEntryField);
                attachAutoResizeListeners();
                attachValidationListeners();
                console.log("Loaded entry:", response);
                if (response.entry.hard && response.entry.hard.trim().length > 0) {
                    showFrontend();
                    // Start session management after successful login
                    startSession();
                } else {
                    alert('Credenciales incorrectas. Intente nuevamente o contacte al administrador.');
                }
            } else if (re_xhr.status === 429) {
                alert('Demasiadas solicitudes. Intente nuevamente más tarde.');
            }
        };
        re_xhr.send();

        var te_xhr = new XMLHttpRequest();
        te_xhr.open('GET', '/total-entries', true);
        te_xhr.setRequestHeader('Authorization', 'Basic ' + encodedCredentials);
        te_xhr.onreadystatechange = function () {
            if (te_xhr.readyState === 4 && te_xhr.status === 200) {
                var response = JSON.parse(te_xhr.responseText);
                // A target of 30000 entries for progress calculation
                var progress = Math.min(100, (response.total / 30000) * 100);
                document.getElementById('progress-percentage').innerText = progress.toFixed(2) + '%';
                // Update progress bar width and color
                progressBar.style.width = progress + '%';
                progressBar.style.background = getProgressColor(progress);
            }
        };
        te_xhr.send();

        loadAndPlotData();
    }

    function showFrontend() {
        loginContainer.style.display = 'none';
        statusBar.style.display = 'block';
        appContainer.style.display = 'block';
        loginContainer.style.display = 'none';
        document.body.style.background = 'white';
        document.querySelector('.container').style.display = 'flex';
        document.getElementById("charts-container").style.display = "block";
    }

    function autoResize(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = (textarea.scrollHeight + 50) + 'px';
    }

    function attachAutoResizeListeners() {
        var textareas = document.querySelectorAll('textarea');
        for (var i = 0; i < textareas.length; i++) {
            autoResize(textareas[i]);
            textareas[i].addEventListener('input', function () {
                autoResize(this);
            });
        }
    }

    function validateForm() {
        var easyText = easyEntryField.value.trim();
        var hardText = hardEntryField.value.trim();
        var lang = languageSelect.value;

        sendButton.disabled = !(easyText.length > 0 && hardText.length > 0 && lang !== 'none');
    }

    function attachValidationListeners() {
        easyEntryField.addEventListener('input', validateForm);
        hardEntryField.addEventListener('input', validateForm);
        languageSelect.addEventListener('change', validateForm);
        validateForm(); // initial check
    }

    function getProgressColor(progress) {
        // Define rainbow steps
        const colors = [
            { pct: 0, color: [255, 0, 0] },      // red
            { pct: 20, color: [255, 165, 0] },   // orange
            { pct: 40, color: [255, 255, 0] },   // yellow
            { pct: 60, color: [0, 128, 0] },     // green
            { pct: 80, color: [0, 0, 255] },     // blue
            { pct: 100, color: [128, 0, 128] }   // purple
        ];

        for (let i = 1; i < colors.length; i++) {
            if (progress <= colors[i].pct) {
                let lower = colors[i - 1];
                let upper = colors[i];
                let range = upper.pct - lower.pct;
                let pct = (progress - lower.pct) / range;

                let color = [
                    Math.round(lower.color[0] + pct * (upper.color[0] - lower.color[0])),
                    Math.round(lower.color[1] + pct * (upper.color[1] - lower.color[1])),
                    Math.round(lower.color[2] + pct * (upper.color[2] - lower.color[2]))
                ];
                return `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
            }
        }
        return "rgb(128,0,128)"; // fallback (purple)
    }

    function loadAndPlotData() {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/stats', true);
        xhr.setRequestHeader('Authorization', 'Basic ' + encodedCredentials);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                // Parse the JSON array directly - backend sends Response.json(stats)
                const lines = JSON.parse(xhr.responseText);
                console.log("Loaded stats:", lines);
                
                if (!lines || lines.length === 0) {
                    console.log("No stats data available");
                    return;
                }
                
                // Extract fields
                // Minus one day (calculation takes place at 2am CET, so it's for the previous day)
                const dates = lines.map(d => new Date(new Date(d.date).getTime() - 1000 * 60 * 60 * 24).toLocaleDateString());
                const newEntries = lines.map(d => d.new_entries);
                const newEasyWords = lines.map(d => d.new_easy_words);
                const newHardWords = lines.map(d => d.new_hard_words);

                // Plot entries
                new Chart(document.getElementById("entriesChart"), {
                    type: 'line',
                    data: {
                        labels: dates,
                        datasets: [
                            {
                                label: 'Nuevas entradas',
                                data: newEntries,
                                borderColor: 'blue',
                                fill: false
                            }
                        ]
                    }
                });

                // Plot words
                new Chart(document.getElementById("wordsChart"), {
                    type: 'line',
                    data: {
                        labels: dates,
                        datasets: [
                            {
                                label: 'Nuevas palabras fáciles',
                                data: newEasyWords,
                                borderColor: 'green',
                                fill: false
                            },
                            {
                                label: 'Nuevas palabras difíciles',
                                data: newHardWords,
                                borderColor: 'red',
                                fill: false
                            }
                        ]
                    }
                });

                // Generate summary
                const metrics = {
                    "Nuevas entradas": newEntries,
                    "Nuevas palabras fáciles": newEasyWords,
                    "Nuevas palabras difíciles": newHardWords
                };

                const tbody = document.querySelector("#summary-table tbody");
                tbody.innerHTML = "";
                Object.keys(metrics).forEach(key => {
                    const values = metrics[key];
                    const min = Math.min(...values);
                    const max = Math.max(...values);
                    const avg = (values.reduce((a, b) => a + b, 0) / values.length).toFixed(2);
                    const current = values[values.length - 1];

                    const row = `<tr>
                        <td>${key}</td>
                        <td>${min}</td>
                        <td>${max}</td>
                        <td>${avg}</td>
                        <td>${current}</td>
                    </tr>`;
                    tbody.innerHTML += row;
                });
            }
        };
        xhr.send();
    }
    
    // Check for existing session on page load
    checkExistingSession();
});